import React from "react";

function Outline() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16 animate__animated animate__fadeInUp">
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4 font-poppins">
              Contact Us
            </h2>
            <p className="text-neutral-600 font-poppins">
              Get in touch with us for any inquiries
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-8 animate__animated animate__fadeInLeft">
              <div className="bg-neutral-50 p-6 rounded-xl">
                <h3 className="text-xl font-semibold text-neutral-900 mb-6 font-poppins">
                  Contact Information
                </h3>

                <div className="space-y-4">
                  <div className="flex items-start space-x-4">
                    <div className="bg-emerald-500/10 p-3 rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-emerald-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        ></path>
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-medium text-neutral-900 font-poppins">
                        Address
                      </h4>
                      <p className="text-neutral-600 mt-1 font-poppins">
                        G-4, Jeevan Sagar Apartment, Malviya Nagar, Bhopal -
                        462003 (Opposite Airtel Office)
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-emerald-500/10 p-3 rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-emerald-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-medium text-neutral-900 font-poppins">
                        Phone
                      </h4>
                      <p className="text-neutral-600 mt-1 font-poppins">
                        <a
                          href="tel:9425024526"
                          className="hover:text-emerald-500 transition-colors"
                        >
                          9425024526
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-emerald-500/10 p-3 rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-emerald-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-medium text-neutral-900 font-poppins">
                        Email
                      </h4>
                      <p className="text-neutral-600 mt-1 font-poppins">
                        <a
                          href="mailto:homeohopes@gmail.com"
                          className="hover:text-emerald-500 transition-colors"
                        >
                          homeohopes@gmail.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-8">
                  <h4 className="font-medium text-neutral-900 mb-4 font-poppins">
                    Clinic Hours
                  </h4>
                  <div className="space-y-2 text-neutral-600 font-poppins">
                    <p>Monday - Saturday: 10:00 AM - 8:00 PM</p>
                    <p>Sunday: Closed</p>
                  </div>
                </div>
              </div>

              <div className="h-[300px] rounded-xl overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.2297164667243!2d77.43227731496814!3d23.233800784848293!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c42834e7f1579%3A0x2f6ee3a8c0e60b0c!2sJeevan%20Sagar%20Apartment!5e0!3m2!1sen!2sin!4v1647941436781!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{
                    border: 0,
                  }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>

            <div className="animate__animated animate__fadeInRight">
              <div className="bg-neutral-50 p-6 rounded-xl">
                <h3 className="text-xl font-semibold text-neutral-900 mb-6 font-poppins">
                  Send us a Message
                </h3>

                <form id="contactForm" className="space-y-6">
                  <div>
                    <label
                      htmlFor="contactName"
                      className="block text-sm font-medium text-neutral-700 mb-2 font-poppins"
                    >
                      Full Name*
                    </label>
                    <input
                      type="text"
                      id="contactName"
                      name="name"
                      required=""
                      className="w-full px-4 py-3 bg-white border border-neutral-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent font-poppins"
                      placeholder="Enter your name"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="contactEmail"
                      className="block text-sm font-medium text-neutral-700 mb-2 font-poppins"
                    >
                      Email Address*
                    </label>
                    <input
                      type="email"
                      id="contactEmail"
                      name="email"
                      required=""
                      className="w-full px-4 py-3 bg-white border border-neutral-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent font-poppins"
                      placeholder="Enter your email"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="contactSubject"
                      className="block text-sm font-medium text-neutral-700 mb-2 font-poppins"
                    >
                      Subject*
                    </label>
                    <input
                      type="text"
                      id="contactSubject"
                      name="subject"
                      required=""
                      className="w-full px-4 py-3 bg-white border border-neutral-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent font-poppins"
                      placeholder="Enter subject"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="contactMessage"
                      className="block text-sm font-medium text-neutral-700 mb-2 font-poppins"
                    >
                      Message*
                    </label>
                    <textarea
                      id="contactMessage"
                      name="message"
                      rows="4"
                      required=""
                      className="w-full px-4 py-3 bg-white border border-neutral-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent font-poppins"
                      placeholder="Enter your message"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3 rounded-full transition-colors inline-flex items-center font-poppins"
                  >
                    <span>Send Message</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Outline;
